export const FEISHU_MARKETPLACE_BIND_TOKEN_KEY = "feishu_marketplace_bind_token";
export const FEISHU_MARKETPLACE_BIND_RETURN_TO_KEY = "feishu_marketplace_bind_return_to";
export const FEISHU_MARKETPLACE_MODE_KEY = "feishu_marketplace_mode";

export function storeFeishuMarketplaceBindToken(bindToken: string, returnTo: string) {
  try {
    sessionStorage.setItem(FEISHU_MARKETPLACE_BIND_TOKEN_KEY, bindToken);
    sessionStorage.setItem(FEISHU_MARKETPLACE_BIND_RETURN_TO_KEY, returnTo || "/");
  } catch (_) {}
}

export function readFeishuMarketplaceBindToken() {
  try {
    return {
      bindToken: sessionStorage.getItem(FEISHU_MARKETPLACE_BIND_TOKEN_KEY) || "",
      returnTo: sessionStorage.getItem(FEISHU_MARKETPLACE_BIND_RETURN_TO_KEY) || "/",
    };
  } catch (_) {
    return { bindToken: "", returnTo: "/" };
  }
}

export function clearFeishuMarketplaceBindToken() {
  try {
    sessionStorage.removeItem(FEISHU_MARKETPLACE_BIND_TOKEN_KEY);
    sessionStorage.removeItem(FEISHU_MARKETPLACE_BIND_RETURN_TO_KEY);
  } catch (_) {}
}

export function readPendingFeishuMarketplaceBindReturnTo() {
  const pending = readFeishuMarketplaceBindToken();
  return pending.bindToken ? pending.returnTo : "";
}

export function markFeishuMarketplaceMode() {
  try {
    sessionStorage.setItem(FEISHU_MARKETPLACE_MODE_KEY, "1");
  } catch (_) {}
}

export function clearFeishuMarketplaceMode() {
  try {
    sessionStorage.removeItem(FEISHU_MARKETPLACE_MODE_KEY);
  } catch (_) {}
}

export function isFeishuMarketplaceMode() {
  try {
    return sessionStorage.getItem(FEISHU_MARKETPLACE_MODE_KEY) === "1";
  } catch (_) {
    return false;
  }
}

export function resolveFeishuMarketplaceMode(search: string) {
  const searchParams = new URLSearchParams(search);
  const feishuAppType = searchParams.get("feishuAppType");
  if (feishuAppType === "marketplace") return true;
  if (feishuAppType === "self_build") return false;
  if (searchParams.has("orgId")) return false;
  return isFeishuMarketplaceMode();
}
